module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-menu-close-96f50e44e89842a73dc20964638b39aa.svg";